export default function setTopBar() {
  const topBarContainer = document.querySelector('[data-top-bar]');
  if (!topBarContainer) return;

  const topBarContent = topBarContainer.querySelector('.top-bar-content');
  if (!topBarContent) return;

  topBarContainer.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-top-bar-coupon]');
    if (!button) return;

    event.preventDefault();
    const label = button.querySelector('[data-top-bar-coupon-label]');
    const couponCode = button.originalCoupon || label?.textContent?.trim();
    if (!label || !couponCode) return;
    button.originalCoupon = couponCode;

    let copied = false;
    if (navigator.clipboard?.writeText) {
      copied = await Promise.race([
        navigator.clipboard.writeText(couponCode).then(() => true).catch(() => false),
        new Promise((resolve) => window.setTimeout(() => resolve(false), 750)),
      ]);
    }

    if (!copied) {
      const textArea = document.createElement('textarea');
      textArea.value = couponCode;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();

      try {
        copied = document.execCommand('copy');
      } catch (_error) {
        copied = false;
      }

      textArea.remove();
    }

    label.textContent = copied ? 'Copiado!' : 'Tente novamente';
    button.classList.toggle('-copied', copied);
    window.clearTimeout(button.copyResetTimer);
    button.copyResetTimer = window.setTimeout(() => {
      label.textContent = couponCode;
      button.classList.remove('-copied');
    }, 2000);
  });

  // Config
  const SPEED = 75; // Pixels por segundo
  let currentPosition = 0;
  let animationActive = true;

  // Clona conteúdo para garantir o loop infinito
  const containerWidth = topBarContainer.offsetWidth;
  const originalChildren = Array.from(topBarContent.children);
  if (originalChildren.length === 0) return;

  if (originalChildren.length === 1) {
    topBarContent.classList.add('-loaded', '-static');
    return;
  }

  const loopDistance = topBarContent.scrollWidth;
  if (loopDistance === 0) return;

  let contentWidth = topBarContent.scrollWidth;
  let cloneCount = 0;
  
  // Clona pelo menos uma vez (para ter original + Cópia)
  originalChildren.forEach(child => {
    const clone = child.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    topBarContent.appendChild(clone);
  });
  contentWidth = topBarContent.scrollWidth;
  cloneCount++;

  // Continua clonando se a largura total (contentWidth) ainda for menor que
  // a largura do container (containerWidth) MAIS a largura do loop (loopDistance)
  while (contentWidth < containerWidth + loopDistance) {
    originalChildren.forEach(child => {
      const clone = child.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      topBarContent.appendChild(clone);
    });
    
    // Atualiza a largura
    contentWidth = topBarContent.scrollWidth;
    cloneCount++;

    // Evita infinite loop
    if (cloneCount > 40) { 
      return;
    }
  }

  topBarContent.classList.add('-loaded');

  // Posiciona o elemento fora da tela para começar
  currentPosition = containerWidth;
  topBarContent.style.transform = `translateX(${currentPosition}px) translateZ(0)`;

  // Animação
  let lastTimestamp = null;
  function animation(timestamp) {
    if (lastTimestamp === null) {
      lastTimestamp = timestamp;
    }

    const delta = timestamp - lastTimestamp;
    lastTimestamp = timestamp;

    if (animationActive) {
      currentPosition -= SPEED * (delta / 1000);

      // Reposiciona o loop quando o conteúdo original inteiro (loopDistance) saiu da tela
      if (currentPosition <= -loopDistance) {
        currentPosition += loopDistance;
      }

      // Aplica a nova posição ao elemento com aceleração 3D
      topBarContent.style.transform = `translateX(${currentPosition}px) translateY(-50%) translateZ(0)`;
    }

    requestAnimationFrame(animation);
  }

  // Controles de interação
  topBarContainer.addEventListener('mouseenter', () => {
    animationActive = false;
  });

  topBarContainer.addEventListener('mouseleave', () => {
    lastTimestamp = null;
    animationActive = true;
  });

  // Inicia a animação
  requestAnimationFrame(animation);
}
